import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface ProductListFiltersAccordionStyles {
    filterAccordion?: InjectableCss;
    accordionHeadingText?: InjectableCss;
    accordionWrapperFilter?: InjectableCss;
}

export const filtersAccordionStyles: ProductListFiltersAccordionStyles = {
    accordionWrapperFilter: {
        css: css`
            width: 70%;
            margin: 85px auto 15px auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin: 0px auto 0px auto;
                    `,
                    css`
                        width: 100%;
                        margin: 0px auto 0px auto;
                    `,
                    css`
                        width: 70%;
                        margin: 85px auto 15px auto;
                    `,
                    css`
                        width: 70%;
                        margin: 85px auto 15px auto;
                    `,
                    css`
                        width: 70%;
                        margin: 85px auto 15px auto;
                    `,
            ])}
        `
    },
    filterAccordion: {
        css: css`
            height: auto;
            overflow: visible;
            visibility: visible;
            margin-bottom: .125em;
            padding: 1.25em;
            border: 1px solid #d5d5d5;
            background: #fff;
            margin-top: -1px;
        `,
    },
    accordionHeadingText: {
        css: css`
            text-transform: uppercase;
            color: #f2f2f2;
            line-height: 12px;
            font-size: 15px;
            border: solid 1px transparent;
            font-weight: 600;
            background-color: #02788c;
            padding: 20px;
            width: fit-content;
            cursor: pointer;
            height: 50px;
            display: flex;
            align-items: center;
            :after{
                content: " ";
                background-image: url(https://galarson.commerce.insitesandbox.com/Themes/GALarsonTheme/Images/icons/golden-arrow.png);
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                display: grid;
                height: 10px;
                width: 10px;
                margin: 0;
                transform: rotate(0deg);
                margin-left: 20px;
            }
            &.show:after{
                transform: rotate(90deg);
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        :after{
                            position: absolute;
                            right: 32px;
                        }
                    `,
                    css`
                        width: 100%;
                        :after{
                            position: absolute;
                            right: 32px;
                        }
                    `,
                    css`
                        
                    `,
                    css`
                        
                    `,
                    css`
                        
                    `,
            ])}
        `
    }
};

const styles = filtersAccordionStyles;

const ProductListFiltersAccordion: FC<Props> = ({ id }) => {
    const [isVisible, setIsVisible] = useState(true);

    const handleToggle = () => {
        setIsVisible(!isVisible);
    };
    return (
        <StyledWrapper {...styles.accordionWrapperFilter}>
            <StyledWrapper {...styles.accordionHeadingText} className={`${isVisible?'show':''}`} onClick={handleToggle}>{translate("FILTERS")}
            </StyledWrapper>
            {isVisible?
            <>
                <StyledWrapper {...styles.filterAccordion}>
                    <Zone contentId={id} zoneName="Content" />
                </StyledWrapper>
            </>:''}
           
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListFiltersAccordion,
    definition: {
        group: "Product List",
        displayName: "Filters Container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
